// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__3pr0w","lds_ring":"Loader_lds_ring__2ejEW","lds-ring":"Loader_lds-ring__1e6Tm","isWhite":"Loader_isWhite__1KTgp"};